import { forEach, map, removeClass } from './utils';

const headerSelector = '.js-header';
const contentSelector = '.js-content';

const productContainerSelector = '.products-container';
const paymentTypeContainerSelector = '.jfPaymentType';
const creditCardAddressSelector = '.jfCreditCardAddress';
const creditCardWrapper = '.jfCreditCardAddress-creditCardWrapper';
const addressWrapper = '.jfCreditCardAddress-addressWrapper';
const emailWrapper = '.jfCreditCardAddress-emailWrapper';
const plaidWrapper = '.jfCreditCardAddress-plaidWrapper';

const labelIdPostfix = {
  creditCard: 'creditCard',
  address: 'address',
  email: 'email',
  paymentType: 'type',
  plaid: 'plaid'
};

const paymentCards = {
  products: 'products',
  paymentType: 'paymentType',
  creditCard: 'creditCard',
  address: 'address',
  email: 'email',
  plaid: 'plaid'
};

const paymentTypes = [
  'control_2co',
  'control_authnet',
  'control_bluepay',
  'control_bluesnap',
  'control_braintree',
  'control_cardconnect',
  'control_chargify',
  'control_clickbank',
  'control_dwolla',
  'control_echeck',
  'control_eway',
  'control_firstdata',
  'control_paypalInvoicing',
  'control_stripeACHManual',
  'control_gocardless',
  'control_googleco',
  'control_onebip',
  'control_payjunction',
  'control_payment',
  'control_paymentwall',
  'control_paymill',
  'control_paypal',
  'control_paypalexpress',
  'control_paypalpro',
  'control_paypalSPB',
  'control_paypalcomplete',
  'control_square',
  'control_stripe',
  'control_stripeACH',
  'control_wepay',
  'control_worldpay',
  'control_worldpayus',
  'control_payu',
  'control_payuMoney',
  'control_pagseguro',
  'control_moneris',
  'control_sensepass',
  'control_sofort',
  'control_skrill',
  'control_paysafe',
  'control_iyzico',
  'control_mollie',
  'control_stripeCheckout',
  'control_payfast'
];

const cloneWrapper = card => {
  return card.wrapperContainer.cloneNode(true);
};

const cloneCard = _card => {
  const card = { ..._card };
  const wrapper = cloneWrapper(card);
  card.wrapperContainer = wrapper;
  card.cardContainer = wrapper.querySelector('.jfCard');
  card.indexContainer = wrapper.querySelector('.jfCard-index');
  card.pressEnterContainer = wrapper.querySelector('.jfPressEnter');
  card.actionsButtons = {
    prev: card.cardContainer.querySelector('.jfCard-actions .forPrev'),
    next: card.cardContainer.querySelector('.jfCard-actions .forNext'),
    submit: card.cardContainer.querySelector('.jfCard-actions .forSubmit'),
    mode: 'middle' // first, last, middle, submit
  };
  return card;
};

const removeSiblings = element => {
  forEach(map(element.parentNode.children, p => p), ch => {
    if (ch !== element) {
      ch.parentNode.removeChild(ch);
    }
  });
};

const setCardLabel = (_card, textContainerElement, postfix) => {
  const card = _card;
  const labelText = textContainerElement.innerText;
  textContainerElement.parentNode.removeChild(textContainerElement);
  const label = card.cardContainer.querySelector('.jfQuestion-label');
  if (label.childNodes && label.childNodes.length && label.childNodes[0].nodeType === 3) {
    label.childNodes[0].nodeValue = labelText;

    // Same label id is broke translations. Adding postfix fixed the issue. (#1267519)
    label.setAttribute('id', `${label.getAttribute('id')}_${postfix}`);
  } else {
    label.innerText = labelText;
  }
};

const getPaymentCard = cards => {
  return cards.find(p => paymentTypes.indexOf(p.question.type) > -1);
};

const constructProductCard = _card => {
  const card = cloneCard(_card);
  card.type = paymentCards.products;
  const productContainer = card.wrapperContainer.querySelector(productContainerSelector);
  removeSiblings(productContainer);

  if (card.question.hideSingleProduct) {
    card.isHidden = true;
    card.forceHide = true;
    card.wrapperContainer.style.display = 'none';
  }

  return card;
};

const constructPaymentMethodCard = _card => {
  const card = cloneCard(_card);
  card.type = paymentCards.paymentType;
  const container = card.wrapperContainer.querySelector(paymentTypeContainerSelector);
  if (container) {
    if (card.question.hideSingleProduct) {
      card.isHidden = true;
      card.forceHide = true;
      card.wrapperContainer.style.display = 'none';
    }
    // remove others
    removeSiblings(container);
    // update card label
    setCardLabel(card, container.querySelector(headerSelector), labelIdPostfix.paymentType);
    removeSiblings(container.querySelector(contentSelector));
    return card;
  }
  return null;
};

const constructCreditCard = _card => {
  const card = cloneCard(_card);
  card.type = paymentCards.creditCard;
  const container = card.wrapperContainer.querySelector(creditCardAddressSelector);

  if (container) {
    const wrapper = container.querySelector(creditCardWrapper);
    if (wrapper) {
      if (container.style.display === 'none') {
        card.isHidden = true;
        card.forceHide = true;
        card.wrapperContainer.style.display = 'none';
      }
      container.removeAttribute('style');
      // remove others
      removeSiblings(container);
      // update card label
      setCardLabel(card, wrapper.querySelector(headerSelector), labelIdPostfix.creditCard);
      removeSiblings(wrapper);
      return card;
    }
  }
  return null;
};

const constructAddressCard = _card => {
  const card = cloneCard(_card);
  card.type = paymentCards.address;
  const container = card.wrapperContainer.querySelector(creditCardAddressSelector);

  if (container) {
    const wrapper = container.querySelector(addressWrapper);

    if (wrapper) {
      if (container.style.display === 'none') {
        card.isHidden = true;
        card.forceHide = true;
        card.wrapperContainer.style.display = 'none';
      }
      container.removeAttribute('style');
      // remove others
      removeSiblings(container);
      // update card label
      setCardLabel(card, wrapper.querySelector(headerSelector), labelIdPostfix.address);
      removeSiblings(wrapper);
      return card;
    }
  }
  return null;
};

const constructEmailCard = _card => {
  const card = cloneCard(_card);
  card.type = paymentCards.email;
  const container = card.wrapperContainer.querySelector(creditCardAddressSelector);

  if (container) {
    const wrapper = container.querySelector(emailWrapper);

    if (wrapper) {
      if (card.question.hideSingleProduct) {
        card.isHidden = true;
        card.forceHide = true;
        card.wrapperContainer.style.display = 'none';
      }
      // remove others
      removeSiblings(container);
      // update card label
      setCardLabel(card, container.querySelector(headerSelector), labelIdPostfix.email);
      removeSiblings(container.querySelector(contentSelector));
      removeSiblings(wrapper);
      return card;
    }
  }
  return null;
};

const constructPlaidCard = _card => {
  const label = 'Bank Account Details';
  const card = cloneCard(_card);
  card.type = paymentCards.plaid;
  const container = card.wrapperContainer.querySelector(creditCardAddressSelector);

  if (container) {
    const wrapper = container.querySelector(plaidWrapper);

    if (wrapper) {
      removeSiblings(container);
      removeSiblings(container.querySelector(contentSelector));
      removeSiblings(wrapper);
      card.label = label;
      card.cardContainer.querySelector('.jsQuestionLabelContainer').innerText = label;
      return card;
    }
  }
  return null;
};

const constructNewCard = (_card, label, type) => {
  const card = cloneCard(_card);
  card.type = type;
  const wrapperSelector = `.jfCreditCardAddress-${type}Wrapper`;
  const container = card.wrapperContainer.querySelector(creditCardAddressSelector);
  if (container) {
    const wrapper = container.querySelector(wrapperSelector);

    if (wrapper) {
      removeSiblings(container);
      removeSiblings(container.querySelector(contentSelector));
      removeSiblings(wrapper);
      card.label = label;
      card.cardContainer.querySelector('.jsQuestionLabelContainer').innerText = label;
      card.cardContainer.querySelector('.jfQuestion-label').style.padding = '0px';
      return card;
    }
  }
  return null;
};

const populateCards = (_cards, labels) => {
  const cards = [..._cards];
  const paymentCard = getPaymentCard(cards);
  if (paymentCard) {
    const oldCardIndex = cards.indexOf(paymentCard);
    const oldPaymentCardWrapper = paymentCard.wrapperContainer; // will be removed;
    const { formLine } = paymentCard; // new cardWrappers will be appeded to this

    const paypalSPBLabel = labels.find(l => l.question && l.question.type === 'control_paypalSPB');

    const newCards = [
      constructProductCard(paymentCard),
      constructEmailCard(paymentCard),
      constructPaymentMethodCard(paymentCard),
      constructCreditCard(paymentCard),
      constructAddressCard(paymentCard),
      constructPlaidCard(paymentCard),
      constructNewCard(paymentCard, paypalSPBLabel ? paypalSPBLabel.label : 'Pay with PayPal', 'paypalSPB')
    ].filter(p => p);

    // remove jfProductModule-wrapper' class;
    newCards.forEach((p, i) => {
      const wrapper = p.wrapperContainer.querySelector('.js-productModuleWrapper');
      if (wrapper) {
        removeClass(wrapper, 'js-productModuleWrapper');
      }

      newCards[i].questionContainer = p.wrapperContainer.querySelector('.jfCard-question');
      newCards[i].actionButtonsWrapper = p.wrapperContainer.querySelector('.jfCard-actions');
    });

    const wrappers = newCards.map(p => p.wrapperContainer);

    cards.splice(oldCardIndex, 1, ...newCards);

    wrappers.forEach(wrapper => {
      formLine.insertBefore(wrapper, oldPaymentCardWrapper);
    });

    formLine.removeChild(oldPaymentCardWrapper);
  }
  return cards;
};

export default {
  populateCards,
  paymentTypes,
  paymentCards
};
